import {
  CreateMeetingPageTemplatePayload,
  MeetingPageTemplateLite,
  UpdateMeetingPageTemplatePayload,
} from 'api/meeting-page-template/types';
import { MeetingPageTemplate } from 'api/meeting-page-template/types';
import { SourceType } from 'api/page-template/types';
import { PageType } from 'api/page-template/types';
import { createPageTemplateHooks } from 'queries/templates';

const meetingPageTemplateHooks = createPageTemplateHooks({
  pageType: PageType.Meeting,
  sourceType: SourceType.Meeting,
  templateType: {} as MeetingPageTemplate,
  templateLiteType: {} as MeetingPageTemplateLite,
  createPayloadType: {} as CreateMeetingPageTemplatePayload,
  updatePayloadType: {} as UpdateMeetingPageTemplatePayload,
});

export const useGetAllMeetingPageTemplatesQuery =
  meetingPageTemplateHooks.useGetAllTemplatesQuery;
export const useGetMeetingPageTemplateQuery =
  meetingPageTemplateHooks.useGetTemplateQuery;
export const useCreateMeetingPageTemplateMutation =
  meetingPageTemplateHooks.useCreateTemplateMutation;
export const useUpdateMeetingPageTemplateMutation =
  meetingPageTemplateHooks.useUpdateTemplateMutation;
export const useDeleteMeetingPageTemplateMutation =
  meetingPageTemplateHooks.useDeleteTemplateMutation;
export const useUpdateMeetingPageTemplateOrderMutation =
  meetingPageTemplateHooks.useUpdateTemplateOrderMutation;
export const useUpdateMeetingPageTemplateStatusMutation =
  meetingPageTemplateHooks.useUpdateTemplateStatusMutation;
